<template>
    <div class="button-radio-container" :title="disabled ? this.disabledMessage : null">
        <div class="btn-group">
            <button
                    class="btn"
                    v-for="option in calculatedOptions"
                    :key="option.value"
                    :class="(disabled ? 'disabled ' : '') + (calculatedValue === option.value ? activeClass : inactiveClass)"
                    v-on:click="onClick(option.value)"
            >
                {{ option.label }}
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'button-radio-container',
        props: {
            cast: {
                type: String,
                default: 'string'
            },
            type: {
                type: String,
                default: 'primary',
            },
            options: {
                type: Object
            },
            defaultValue: {
                default: null
            },
            value: {
                default: null
            },
            disabled: {
                default: false,
                type: Boolean,
            },
            disabledMessage: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                internalValue: this.value !== null ? this.value : this.defaultValue,
            }
        },
        computed: {
            activeClass() {
                return `btn-${this.type}`;
            },
            inactiveClass() {
                return `btn-outline-${this.type}`;
            },
            calculatedOptions() {
                let options = this.options;

                let calculatedOptions = [];

                for (let key in options) {
                    let label = options[key];

                    calculatedOptions.push({
                        value: this.castValue(key),
                        label: label,
                    });
                }

                return calculatedOptions;
            },
            calculatedValue() {
                return this.castValue(this.internalValue);
            }
        },
        methods: {
            castValue(value) {
                if (value === null) {
                    return null;
                }

                switch (this.cast) {
                    case 'string':
                        return value.toString();
                    case 'integer':
                    case 'int':
                        return parseInt(value, 10);
                    case 'float':
                        return parseFloat(value);
                    case 'boolean':
                        return !!value;
                }

                return value;
            },
            onClick(value) {
                if (this.disabled) {
                    return;
                }

                this.internalValue = value;
            }
        },
        watch: {
            internalValue(internalValue) {
                this.$emit('input', internalValue);
            },
            value(value) {
                this.internalValue = value;
            }
        },
    }
</script>

<style lang="scss" scoped>
    .btn {
        margin-left: 15px;
    }

    .button-radio-container {
        &.disabled {
            opacity: .6;

            .btn {
            }
        }
    }
</style>